import { createSlice } from "@reduxjs/toolkit";

export const resizeSlice = createSlice({
  name: "resize",
  initialState: false,
  reducers: {
    toogleResize: (_state, action) => {
      return action.payload; // Просто возвращаем новое значение state
    },
  },
});

export const { toogleResize } = resizeSlice.actions;
export default resizeSlice.reducer;